export const FormLang = {
    forgetPass: 'فراموشی رمز عبور',
    enterKiosk: ' ورود کیوسک',
    enter: 'ورود',
    question: 'آیا می خواهید وارد کیوسک شوید؟',
    error: 'اطلاعات وارد شده صحیح نیست',
    myWS: 'فضای کاری من',
    err: 'دریافت اطلاعات با خطا مواجه شد لطفا دوباره تلاش کنید',
    email: 'ایمیل',
    password: 'رمز عبور',
    captchaErr: 'لطفا مشخص کنید ربات نیستد',
};
